<div class="card grupo-usuario-container">
    <p-toolbar styleClass="mb-4 grupo-usuario-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"
                [disabled]="permissaoService.can('grupos_do_usuario_inserir') == false"></button>
        </ng-template>

    </p-toolbar>

    <div class="grupo-usuario-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','nome','ativo','usuario_interno']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="p-m-0">Perfil</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Ativo
                </th>
                <th>Nome
                </th>
                <th>Interno
                </th>
                <th>Data do cadastro
                </th>
                <th>Editar</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Ativo: </span>{{dt.ativo ? "Sim" : "Não"}}</td>
                <td><span class="p-column-title negrito">Nome: </span>{{dt.nome}}</td>
                <td><span class="p-column-title negrito">Interno: </span>{{dt.usuario_interno ? "Sim" : "Não"}}</td>

                <td><span class="p-column-title negrito">Data do cadastro: </span>{{dt.created_at | date:
                    'dd/MM/yyyy' }}</td>
                <td style="text-align: center;">
                    <span class="p-column-title negrito">Editar: </span>
                    <button pButton pRipple [disabled]="permissaoService.can('grupos_do_usuario_editar') == false"
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        (click)="edit(dt)"></button>
                </td>



            </tr>
        </ng-template>

        </p-table>
    </div>
</div>


<p-dialog header="Perfil" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">
            <div class="field col-12 md:col-12 xl:col-12">
                <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                <label class="form-check-label" for="ativo">Ativo</label>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <input type="checkbox" class="form-check-input" id="usuario_interno" formControlName="usuario_interno">
                <label class="form-check-label" for="usuario_interno">Para Usuário Interno</label>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <label for="nome" class="block mb-1">Nome</label>
                <input type="text" id="nome" pInputText formControlName="nome" class="w-full">
            </div>


        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
